import i18n, { InitOptions } from 'i18next';

import * as EN from 'locales/en';
import * as ES from 'locales/es';

export const SELECTED_LANGUAGE_KEY = 'i18nextLng' as const;

// the translations
const resources = {
  es: ES,
  en: EN,
};

let lng = localStorage.getItem(SELECTED_LANGUAGE_KEY);
if (!lng) {
  lng = 'es';
  localStorage.setItem(SELECTED_LANGUAGE_KEY, lng);
}

const options: InitOptions = {
  interpolation: {
    escapeValue: false, // not needed for react!!
  },
  debug: false /* process.env.NODE_ENV !== 'production' */,
  lng,
  resources,

  fallbackLng: lng,

  ns: ['common'],

  defaultNS: 'common',

  react: {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
    useSuspense: true,
  },
};

i18n.on('languageChanged', function (lng) {
  localStorage.setItem(SELECTED_LANGUAGE_KEY, lng);
});

i18n.init(options).then();

export default i18n;
